import axios from "axios";
import { FC, useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { SocketContext, TeamContext, UserContext } from "../context";
import { InitialPage } from "../pages";

const InitialRoute: FC<{}> = () => {
    const { teamNumber } = useContext(TeamContext);
    const { socket } = useContext(SocketContext);
    const { userData } = useContext(UserContext);

    const windowLocationHref = window.location.href;
    const urlPathChunks = windowLocationHref.split("/");
    const urlTokenExtracted = urlPathChunks[urlPathChunks.length-1];
    let playerEmail = localStorage["userEmailInCaseHeLogsOut"];
    let history = useHistory();

    // if(isLoaderHidden)
    //     return <Loader />;


    const reconnectToTheActiveGame = () => {
		axios({
			method: "get",
			url: process.env.REACT_APP_BACKEND_URL + `api/matches/is-game-running/${urlTokenExtracted}`,
		})
		.then((res: any) => {
            if(res.data.isGameRunning) {
                if(res.data.playerEmails.find((email: string) => { return playerEmail === email })) {
                    let payload = {
                        matchId: urlTokenExtracted,
                        gameId: 1,
                        player: {
                            email: playerEmail,
                        }
                    }
                    socket?.emit("facilitatorInstedOfPlayer", payload);
                    history.push("/slotmachine/" + urlTokenExtracted);
                }
            }
		})
		.catch((err: any) => console.error(err));
	}

    useEffect(() => {
        reconnectToTheActiveGame();
    }, [])

    return (
        <div>
           {(!teamNumber || !userData) && <InitialPage />}
        </div>
    );
}

export default InitialRoute;